import { createSelector } from '@reduxjs/toolkit'
import _groupBy from 'lodash/groupBy'
import _sortBy from 'lodash/sortBy'
import _path from 'lodash/fp/path'

import { makeFetchSelectors } from 'app/redux-fetch/selectors'
import { RootState } from 'app/store'
import { licensesDefaultSort } from 'features/licenses/utils'
import { rootDomainsDataSelector } from 'features/rootDomains/selectors'

import {
  LICENSES_COLLAPSE_STATE_REDUCER_NAME,
  IMPORT_LICENSE_REDUCER_NAME,
  LICENSES_LIST_REDUCER_NAME,
  LICENSES_REDUCER_NAME,
  TRANSFER_LICENSE_REDUCER_NAME,
} from './consts'
import type { LicenesCollapseState, LicenseType } from './types'

export const licensesSelector = makeFetchSelectors(
  LICENSES_REDUCER_NAME,
  LICENSES_LIST_REDUCER_NAME
)

export const licensesGroupsSelector = createSelector(
  licensesSelector.data,
  (licensesData) => {
    const licenses = licensesData || []
    const groups = _groupBy(licenses, (license: LicenseType) => license.name)

    return _sortBy(groups, licensesDefaultSort)
  }
)

export const licensesListIsFetchingSelector = createSelector(
  [rootDomainsDataSelector.isFetching, licensesSelector.isFetching],
  (rootDomainIsFetching, licensesListIsFetching) =>
    rootDomainIsFetching || licensesListIsFetching
)

export const licensesListErrorSelector = createSelector(
  [rootDomainsDataSelector.error, licensesSelector.error],
  (rootDomainError, licensesListError) => rootDomainError || licensesListError
)

export const licensesListIsFinishedSelector = createSelector(
  [rootDomainsDataSelector.isFinished, licensesSelector.isFinished],
  (rootDomainIsFinished, licensesListIsFinished) =>
    rootDomainIsFinished && licensesListIsFinished
)

export const importLicenseSelector = makeFetchSelectors(
  LICENSES_REDUCER_NAME,
  IMPORT_LICENSE_REDUCER_NAME
)

export const transferLicenseSelector = makeFetchSelectors(
  LICENSES_REDUCER_NAME,
  TRANSFER_LICENSE_REDUCER_NAME
)
export const collapseStateSelector = (state: RootState): LicenesCollapseState =>
  _path([LICENSES_REDUCER_NAME, LICENSES_COLLAPSE_STATE_REDUCER_NAME])(state)
